import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import $ from 'jquery';
import * as c from '../helpers/constants'

//REDUX
import { connect } from 'react-redux';

class Error404 extends React.Component
{
    constructor(props)
    {
        super(props);

        document.body.style = 'background: #f6f6f6;';
    }

    render()
    {
        const auth = this.props.auth;
        const defaultRoute = (auth.isAuthenticated ? c.DEFAULT_PRIVATE_ROUTE : c.DEFAULT_PUBLIC_ROUTE);

        return (
            <div className="container h-100">
                <div className="row h-100 justify-content-center align-items-center text-center">
                    <div className="col-12 mb-5">
                        <h1 className="display-1">
                            404
                        </h1>

                        <h2 className="">
                            A página solicitada não foi encontrada. 
                        </h2>

                        <div className="mb-0 py-4 px-0 text-center">
                            <Link to={defaultRoute} className="btn btn-lg btn-outline btn-secondary px-5 py-3">
                                VOLTAR 
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Error404));
